import { UserDisplay } from "@coaching-culture/types";
import {
  Box,
  Flex,
  LinkButton,
  Text,
  UserProfileImage,
} from "@coaching-culture/ui";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { SpaceProps } from "styled-system";

const StyledLink = styled(Link)`
  font-weight: 500;
`;

export type UserFlagProps = {
  user: UserDisplay | null;
  to?: string;
  onClick?: () => void;
} & SpaceProps;

export function UserFlag({ user, to, onClick, ...rest }: UserFlagProps) {
  let name = user?.name ?? "Unknown User";

  if (user?.isDeactivated) {
    name = name + " (Inactive)";
  }

  return (
    <Flex alignItems="center" {...rest}>
      <UserProfileImage
        mr={2}
        profileImage={user?.profileImage}
        name={user?.name ?? "?"}
      />
      <Box>
        {to != null ? (
          <StyledLink className="cc-user-name" to={to} onClick={onClick}>
            {name}
          </StyledLink>
        ) : onClick != null ? (
          <LinkButton className="cc-user-name" onClick={onClick}>
            {name}
          </LinkButton>
        ) : (
          <Text className="cc-user-name" fontWeight={500}>
            {name}
          </Text>
        )}
        <Text fontSize="80%" color="grey2">
          {user?.email ?? ""}
        </Text>
      </Box>
    </Flex>
  );
}
